import { useRouter } from "next/router";
import { useSWRConfig } from "swr";

import { isValid } from "date-fns";

import { SK_CHANNEL } from "hooks/useActionCable";
import { useChannel } from "hooks/useChannel";
import { useGlobalState } from "hooks/useGlobalState";

import PeersTradeComparisonHeader from "./Header";
import PeersTradeComparison, {
  mnaPeersComparisonUrl,
} from "./PeersTradeComparison";
import PeersTransactionsComparison, {
  mnaTransactionsComparableUrl,
} from "./PeersTransactionsComparison";

export default function ToolMnaTransactionsComparable() {
  const router = useRouter();
  const entityId = router?.query["entity-id"] as string;
  const { mutate: globalMutate } = useSWRConfig();
  const [_mnaPeersComparisonLoading, setMnaPeersComparisonLoading] =
    useGlobalState(`mnaPeersComparisonLoading-${entityId}`);

  const [_mnaTransactionsLoading, setMnaTransactionsLoading] = useGlobalState(
    `mnaTransactionsLoading-${entityId}`
  );

  useChannel({
    key: "MergingAcquisition",
    name: `merging-acquisitions`,
    channel: {
      channel: SK_CHANNEL,
      room: `merging-acquisitions`,
    },
    onReceived: async (message: any) => {
      const { event, comparables, transactions, entity_id } = message;

      console.log(event, entity_id, entityId);
      console.log(transactions, comparables);

      if (Number(entity_id) !== Number(entityId)) {
        return;
      }

      if (event === "peers-comparison-generated") {
        globalMutate(mnaPeersComparisonUrl(entityId), comparables).then(() => {
          console.log("mutated peers-comparison", comparables);
        });
        setMnaPeersComparisonLoading(false);
      } else if (event === "transactions-comparison-generated") {
        globalMutate(
          mnaTransactionsComparableUrl(entityId),
          transactions.map((t: any) => {
            const splited_date = t.announcement_date.split("-");
            const announcement_date = isValid(new Date(t.announcement_date))
              ? new Date(t.announcement_date)
              : new Date(splited_date[2], splited_date[1] - 1, splited_date[0]);

            return {
              ...t,
              announcement_date,
              stake_acquired: t?.stake_acquired?.replace("%", ""),
            };
          })
        ).then(() => {
          console.log("mutated transactions-comparison", transactions);
        });
        setMnaTransactionsLoading(false);
      }
    },
  });

  return (
    <div className="mt-[15px]">
      <div className="mt-[30px] px-[20px]">
        <h1 className="mb-0 font-bold text-2xl">Comparables</h1>
        <p className="text-sm">
          Publicly Traded Comparables and Precedent Transactions
        </p>
        <div id="analytic-content">
          <PeersTradeComparisonHeader />
          <PeersTradeComparison />
          <PeersTransactionsComparison />
        </div>
      </div>
    </div>
  );
}
